import * as S from './styles';

interface LectureTimeProps {
  startTime: string;
  endTime: string;
  todayDate?: string;
}

const LectureTime = ({ todayDate, startTime, endTime }: LectureTimeProps) => {
  return (
    <S.TimeHeader>
      <S.DateBox>{todayDate}</S.DateBox>
      <S.TimeBox>
        {startTime}
        <S.TimeDivider>-</S.TimeDivider>
        {endTime}
      </S.TimeBox>
    </S.TimeHeader>
  );
};

export default LectureTime;
